import React, { useEffect, useState } from 'react';
import { XIcon, MessageSquareIcon } from 'lucide-react';
const NAMES = ['María Laura', 'Carolina', 'Valentina', 'Sofía', 'Ana María', 'Luciana', 'Florencia', 'Camila', 'Julieta', 'Martina', 'Paula', 'Agustina', 'Romina', 'Daniela', 'Gabriela'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Formosa', 'San Luis', 'Bahía Blanca'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [currentPerson, setCurrentPerson] = useState({
    name: '',
    city: ''
  });
  const getRandomPerson = () => {
    const name = NAMES[Math.floor(Math.random() * NAMES.length)];
    const city = CITIES[Math.floor(Math.random() * CITIES.length)];
    return {
      name,
      city
    };
  };
  useEffect(() => {
    // Initial delay before first popup
    const initialDelay = setTimeout(() => {
      setCurrentPerson(getRandomPerson());
      setIsVisible(true);
    }, 3000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    // Auto-hide after 5 seconds
    const hideTimeout = setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => {
        setIsVisible(false);
        setIsExiting(false);
      }, 500);
    }, 5000);
    // Show next popup after 7-12 seconds
    const nextTimeout = setTimeout(() => {
      setCurrentPerson(getRandomPerson());
      setIsVisible(true);
    }, 7000 + Math.random() * 5000);
    return () => {
      clearTimeout(hideTimeout);
      clearTimeout(nextTimeout);
    };
  }, [isVisible]);
  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsExiting(false);
    }, 500);
  };
  if (!isVisible) return null;
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm ${isExiting ? 'popup-exit' : 'popup-enter'}`} data-id="element-193">
      <div className="bg-white rounded-lg shadow-2xl p-4 flex items-start gap-3 border border-gray-200" data-id="element-194">
        {/* Icon */}
        <div className="flex-shrink-0 w-10 h-10 bg-[#F5C842]/20 rounded-full flex items-center justify-center" data-id="element-195">
          <MessageSquareIcon className="w-5 h-5 text-[#D4AF37]" data-id="element-196" />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0" data-id="element-197">
          <p className="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-1" data-id="element-198">
            ALGUIEN ACABA DE COMPRAR
          </p>
          <p className="text-sm font-bold text-gray-900 mb-1" data-id="element-199">
            Sistema Pro Cartas Natales
          </p>
          <p className="text-sm text-gray-600" data-id="element-200">
            {currentPerson.name} de {currentPerson.city}
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-201">Hace unos instantes</p>
        </div>

        {/* Close Button */}
        <button onClick={handleClose} className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar notificación" data-id="element-202">
          <XIcon className="w-4 h-4" data-id="element-203" />
        </button>
      </div>
    </div>;
}